"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARGIN = void 0;
exports.MARGIN = {
    '2D': { top: 100, right: 50, bottom: 70, left: 100 },
    '1D': {
        top: 10,
        right: 10,
        bottom: 50,
        left: 10,
    },
};
